/* src/app/app.component.scss */
ion-split-pane {
  background-color: #002941;
}
ion-router-outlet {
  box-shadow: none !important;
  --box-shadow: none !important;
}
ion-menu {
  border-right: 1px solid #002941 !important;
}
ion-menu ion-content {
  --background: #ffffff;
}
ion-menu {
  max-width: 320px;
  --background: #ffffff;
}
.logo {
  cursor: default;
  -webkit-user-select: none;
  user-select: none;
  pointer-events: none;
  background-color: #0e4c6b;
  display: flex;
  align-items: center;
  color: white;
  font-weight: bold;
  font-size: 18px;
  width: fit-content;
}
.logo img {
  margin-right: 8px;
}
img {
  height: 30px;
}
.logo-wrap {
  background-color: #0e4c6b;
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-wrap {
  width: 100%;
  flex: 1;
  overflow-y: auto;
}
.menu-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=app.component.css.map */
